import { StepsAnimationWrapper } from './style'
import React from 'react'

const StepsAnimation = ({ children, path }) => {
	return <StepsAnimationWrapper>{children}</StepsAnimationWrapper>
}
export default StepsAnimation
